module.exports = __webpack_public_path__ + "img/car.ec352b5a.svg";